import { render } from "./index.vue?vue&type=template&id=45940e9e&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=45940e9e&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=45940e9e&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45940e9e"]])

export default __exports__